import * as React from 'react';
function LogoXINGButterflyWhite(props) {
    return (React.createElement("svg", { viewBox: "0 0 28 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "LogoXINGButterflyWhite", ...props },
        React.createElement("g", { clipPath: "url(#prefix__clip0_47_1375)", fillRule: "evenodd", clipRule: "evenodd", fill: "#fff" },
            React.createElement("path", { d: "M1.83 5.984l3.688 6.479L0 22.018h6.585l5.479-9.555-3.688-6.48H1.831zM21.428 0L10.786 18.642 17.648 31h6.678l-6.98-12.358L28 0h-6.572z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "prefix__clip0_47_1375" },
                React.createElement("path", { fill: "#fff", d: "M0 0h28v31H0z" })))));
}
export default LogoXINGButterflyWhite;
//# sourceMappingURL=LogoXINGButterflyWhite.js.map